import { createFileRoute } from "@tanstack/react-router";
import MolinaMarketplaceInsurance, {
  config,
} from "@/pages/MolinaMarketplaceInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/molina-marketplace-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Molina Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Molina Marketplace insurance for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Molina Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Molina Marketplace insurance for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/molina-marketplace-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/molina-marketplace-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MolinaMarketplaceInsurance />;
}
